var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog activity-create-dialog",
      attrs: {
        title: _setup.dialogTitle,
        visible: _vm.visible,
        width: "1200px",
        top: "5vh",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: { close: _setup.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-body-scroll" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _setup.localForm,
                rules: _setup.formRules,
                "label-position": "right",
                "label-width": "120px",
                size: "mini",
              },
            },
            [
              _c("div", { staticClass: "section-head" }, [_vm._v("配置信息")]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _setup.actType !== _setup.ACT_TYPE_LINK
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动标题",
                                prop: "title",
                                required: "",
                              },
                            },
                            [
                              _c(_setup.LanguageInput, {
                                staticStyle: { width: "350px" },
                                attrs: {
                                  lang: _setup.localForm.desc_lang,
                                  placeholder: "请输入标题",
                                  maxlength: 128,
                                  "show-word-limit": true,
                                  clearable: "",
                                },
                                on: {
                                  "update:lang": function ($event) {
                                    return _vm.$set(
                                      _setup.localForm,
                                      "desc_lang",
                                      $event
                                    )
                                  },
                                },
                                model: {
                                  value: _setup.localForm.title,
                                  callback: function ($$v) {
                                    _vm.$set(_setup.localForm, "title", $$v)
                                  },
                                  expression: "localForm.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    {
                      attrs: {
                        span: _setup.actType === _setup.ACT_TYPE_LINK ? 10 : 12,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动类型", prop: "actType" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "240px" },
                              attrs: { disabled: _setup.props.mode === "edit" },
                              model: {
                                value: _setup.localForm.actType,
                                callback: function ($$v) {
                                  _vm.$set(_setup.localForm, "actType", $$v)
                                },
                                expression: "localForm.actType",
                              },
                            },
                            _vm._l(_setup.ACT_TYPE_OPTIONS, function (opt) {
                              return _c("el-option", {
                                key: opt.value,
                                attrs: {
                                  label: opt.label,
                                  value: opt.value,
                                  disabled:
                                    (opt.value === 2 &&
                                      _setup.props.hasRedEnvelopeRain) ||
                                    (opt.value === 4 &&
                                      _setup.props.hasSignIn) ||
                                    (opt.value === 6 &&
                                      _setup.props.hasAgentRewardBox) ||
                                    (opt.value === 7 &&
                                      _setup.props.hasLossCashback) ||
                                    (opt.value === 8 &&
                                      _setup.props.hasTotalDepositReward) ||
                                    (opt.value === 9 &&
                                      _setup.props.hasFirstDepositReward) ||
                                    (opt.value === 1 &&
                                      _setup.props.hasSpinLuck),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _setup.actType !== _setup.ACT_TYPE_LINK
                ? _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动时间",
                                prop: "activityTimeRange",
                                required: "",
                              },
                            },
                            [
                              _setup.props.mode !== "edit" ||
                              (_vm.activityData?.start_at === -1 &&
                                _vm.activityData?.end_at === -1)
                                ? _c(
                                    "div",
                                    { staticStyle: { width: "340px" } },
                                    [
                                      _c(_setup.DateTimeRangePicker, {
                                        model: {
                                          value:
                                            _setup.localForm.activityTimeRange,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _setup.localForm,
                                              "activityTimeRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "localForm.activityTimeRange",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.activityData
                                            ?.activityTimeRangeText
                                        )
                                      ),
                                    ]),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _setup.actType === 9
                ? _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "展示时间",
                                prop: "displayTimeRange",
                                required: "",
                              },
                            },
                            [
                              _setup.props.mode !== "edit"
                                ? _c(
                                    "div",
                                    { staticStyle: { width: "340px" } },
                                    [
                                      _c(_setup.DateTimeRangePicker, {
                                        attrs: {
                                          placeholder: "请选择展示时间范围",
                                        },
                                        model: {
                                          value:
                                            _setup.localForm.displayTimeRange,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _setup.localForm,
                                              "displayTimeRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "localForm.displayTimeRange",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.activityData
                                            .displayTimeRangeText || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动状态", prop: "status" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _setup.localForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_setup.localForm, "status", $$v)
                                },
                                expression: "localForm.status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("立即开启"),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("停用"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "status-tip",
                              staticStyle: { "margin-left": "10px" },
                            },
                            [
                              _vm._v(
                                " 立即开启，将根据设定的活动时间判断，若活动周期为永久则马上开启活动 "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _setup.actType !== _setup.ACT_TYPE_LINK
                ? _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "奖励有效期",
                                prop: "reward_expire_days",
                                required: "",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  disabled: _setup.props.mode === "edit",
                                  min: 0,
                                  precision: 2,
                                  controls: false,
                                  placeholder: "中奖后多久有效",
                                },
                                model: {
                                  value: _setup.localForm.reward_expire_days,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _setup.localForm,
                                      "reward_expire_days",
                                      $$v
                                    )
                                  },
                                  expression: "localForm.reward_expire_days",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "status-tip",
                                  staticStyle: { "margin-left": "10px" },
                                },
                                [_vm._v("天")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "活动排序", prop: "sort" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "80px" },
                                attrs: {
                                  min: 0,
                                  precision: 0,
                                  controls: false,
                                  placeholder: "请输入活动排序",
                                },
                                model: {
                                  value: _setup.localForm.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_setup.localForm, "sort", $$v)
                                  },
                                  expression: "localForm.sort",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "status-tip",
                                  staticStyle: { "margin-left": "10px" },
                                },
                                [_vm._v("数字越大，活动越靠前")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动封面", prop: "icon" } },
                        [
                          _c(_setup.SingleImageUpload, {
                            attrs: {
                              size: 120,
                              "allowed-types": ["jpeg", "jpg", "png", "gif"],
                            },
                            model: {
                              value: _setup.localForm.icon,
                              callback: function ($$v) {
                                _vm.$set(_setup.localForm, "icon", $$v)
                              },
                              expression: "localForm.icon",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _setup.currentTypeModule && _setup.currentTypeModule.component
                ? _c(_setup.currentTypeModule.component, {
                    tag: "component",
                    attrs: {
                      "local-form": _setup.localForm,
                      "rule-flags": _setup.ruleFlags,
                      "rule-values": _setup.ruleValues,
                      "red-rule-flags": _setup.redRuleFlags,
                      "red-rule-values": _setup.redRuleValues,
                      "vip-options": _setup.vipOptions,
                    },
                    on: {
                      syncVipCheckAllState: _setup.syncVipCheckAllState,
                      onVipCheckAllChange: _setup.onVipCheckAllChange,
                    },
                  })
                : _vm._e(),
              _setup.actType !== _setup.ACT_TYPE_LINK
                ? _c("div", { staticClass: "section-head" }, [
                    _vm._v("活动说明"),
                  ])
                : _vm._e(),
              _setup.actType !== _setup.ACT_TYPE_LINK
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "desc-form-item",
                      attrs: { label: " ", "label-width": "0", prop: "desc" },
                    },
                    [
                      _c(_setup.LanguageTextarea, {
                        attrs: {
                          lang: _setup.localForm.desc_lang,
                          rows: 6,
                          placeholder: "请输入活动说明",
                          maxlength: 2000,
                          "show-word-limit": true,
                        },
                        on: {
                          "update:lang": function ($event) {
                            return _vm.$set(
                              _setup.localForm,
                              "desc_lang",
                              $event
                            )
                          },
                        },
                        model: {
                          value: _setup.localForm.desc,
                          callback: function ($$v) {
                            _vm.$set(_setup.localForm, "desc", $$v)
                          },
                          expression: "localForm.desc",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _setup.handleClose } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _setup.submitting,
                size: "mini",
              },
              on: { click: _setup.handleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }